import { requireRouteAudience } from '@services/router/routeAccess'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/timetables/$type/$identifier')({
    beforeLoad: requireRouteAudience(['staff']),
    staticData: {
        crumb: {
            label: (match) => match.params.identifier,
        },
    },
})
